import get from 'lodash.get';
import { FormattedMessage } from 'react-intl';
import { defaultCurrency } from '../../default-props/default-currency';
import { CurrencyPropType } from '../../prop-types/currency';

import FormattedCurrencyContainer from '../formatted-currency/container';
import style from './item-display.module.less';

export const ItemDisplayPriceWrapper = ({ totalPrice = defaultCurrency, unitPrice = defaultCurrency }) => {
  const totalPriceValue = get(totalPrice, 'value', 0);
  const totalPriceCode = get(totalPrice, 'code', 'USD');
  const unitPriceValue = get(unitPrice, 'value', 0);
  const unitPriceCode = get(unitPrice, 'code', 'USD');
  return (
    <div className={style['price-wrapper']}>
      <div className={style['price-content']}>
        <div className={style['total-price']}>
          <FormattedCurrencyContainer currencyCode={totalPriceCode} value={totalPriceValue} />
        </div>
        <div className={style['unit-price']}>
          <FormattedMessage
            defaultMessage='{currency} ea'
            description='itemDisplay.unitPrice'
            id='rACyKs'
            values={{
              currency: <FormattedCurrencyContainer currencyCode={unitPriceCode} value={unitPriceValue} />,
            }}
          />
        </div>
      </div>
    </div>
  );
};

ItemDisplayPriceWrapper.propTypes = {
  totalPrice: CurrencyPropType,
  unitPrice: CurrencyPropType,
};
